export const pt = {
  language: "PT",
  currency: "R$",
  actions: "Ações",
  add: "Adicionar",
  apply: "Aplicar",
  apps: "Aplicativos",
  attach: "Anexar",
  cancel: "Cancelar",
  clear: "Limpar",
  close: "Fechar",
  column: "Coluna",
  completed: "Concluído",
  continue: "Continuar",
  create: "Criar",
  delete: "Excluir",
  disabled: "Inativado",
  edit: "Editar",
  enabled: "Ativado",
  error: "Erro",
  expand: "Expandir",
  export: "Exportar",
  filter: "Filtrar",
  filterNoun: "Filtro",
  finish: "Concluir",
  help: "Ajuda",
  subscribeNow: "Assine Agora",
  import: "Importar",
  indicators: "Indicadores",
  link: "Vincular",
  loading: "Carregando",
  logout: "Sair",
  measurement: "Medição",
  name: "Nome",
  next: "Próximo",
  optional: "Opcional",
  or: "ou",
  password: "Senha",
  profile: "Perfil",
  readjustiment: "Reajuste",
  register: "Cadastrar",
  reset: "Redefinir",
  resetPassword: "Redefinir senha",
  changePassword: "Alterar senha",
  returnHome: "Retornar à Homepage",
  returnPreviousPage: "Retornar à página anterior",
  save: "Salvar",
  search: "Pesquisar",
  select: "Selecionar",
  selectedItems: "%s selecionado(s)",
  settings: "Configurações",
  share: "Compartilhar",
  start: "Iniciar",
  timeLeft: "Tempo restante estimado",
  today: "Hoje",
  tryAgain: "Tentar novamente",
  undefined: "Indefinido",
  upTo: "até",
  user: "Usuário",
  users: "Usuários",
  view: "Visualizar",
  exceptions: {
    invalidParam: "O campo %s é inválido",
    requiredParam: "O campo %s é obrigatório",
    immutableParam: "Você não pode alterar o campo %s",
    invalidValue: "Valor do campo %s é inválido",
    greaterThan: "O valor do campo %s deve ser maior que %s",
    greaterThanOrEqual: "O valor do campo %s deve ser maior ou igual a %s",
    lessThan: "O valor do campo %s deve ser menor que %s",
    lessThanOrEqual: "O valor do campo %s deve ser menor ou igual a %s",
    betweenValues: "O valor do campo %s deve estar entre %s e %s",
    lengthString: "O tamanho do campo %s deve ser igual a %s",
    maxAndMinLengthString: "O tamanho do campo %s deve estar entre %s e %s",
    maxLengthString: "O tamanho do campo %s deve ser menor que %s",
    minLengthString: "O tamanho do campo %s deve ser maior que %s",
    mustBeInteger: "O valor do campo %s deve ser um número inteiro",
    onlyNumbers: "O valor do campo %s deve conter apenas números",
    invalidDate: "Data inválida",
    invalidEmail: "Email inválido",
    invalidCPF: "CPF inválido",
    invalidUrl: "URL inválida",
    invalidCredentials: "Usuário e/ou senha inválidos.",
    networkError: "Falha na conexão com a internet!",
    auth: {
      "login-error":
        "Não foi possível efetuar o login com as informações indicadas.",
      "register-error":
        "Não foi possível efetuar o registro com as informações indicadas.",
      "password-reset-error":
        "Não foi possível enviar o email para resetar a senha.",
      "account-exists-with-different-credential":
        "Conta existe com outra credencial de autenticação.",
      "invalid-email": "E-mail inválido!",
      "email-already-in-use": "E-mail já encontra-se em uso!",
      "user-not-found": "Usuário não encontrado!",
      "wrong-password": "A combinação de e-mail e senha não é válida!",
      "internal-error":
        "Erro interno! Por favor, entre em contado com nosso suporte.",
      "network-request-failed":
        "Falha na rede! Por favor, verifique se sua rede está conectada corretamente.",
      "too-many-requests":
        "Login bloqueado por muitas tentativas erradas! Por favor, tente novamente mais tarde.",
      "requires-recent-login":
        "Esta ação requer um login recente! Deslogue e logue novamente nesta conta.",
      "user-disabled":
        "Usuário desabilitado! Por favor, entre em contato com seu administrador.",
      "invalid-user":
        "Usuário sem permissão de Acesso! Por favor, entre em contato com seu administrador.",
    },
    contract: {
      invalidUserShared:
        "O contrato só pode ser compartilhado com ao menos um Usuário válido.",
      invalidTaxes: "Os impostos devem conter valores númericos.",
      invalidDate: "A data não pode ser superior que a data atual",
      coverNotFound: "Imagem de capa não foi encontrada no caminho %s.",
    },
    megaIntegration: {
      networkError:
        "Falha na conexão com a API Mega! \nVerifique sua conexão com a internet e se a URL está configurada corretamente.",
      invalidCredentials:
        "Falha na conexão com a API Mega! \nUsuário e/ou senha inválidos.",
      userNotFound:
        "Usuário '%s' não encontrado ou senha incorreta! \nVerifique se sua senha está correta e se o seu usuário está cadastrado corretamente no ERP Mega.",
      userBlocked:
        "Usuário '%s' está bloqueado! \nAcesse o ERP Mega para desbloquear seu usuário.",
      noAccessPermission:
        "Usuário '%s' não possui permissão de acesso ao módulo 'API'! \nAcesse o ERP Mega para alterar a permissão do seu usuário.",
      quotationNotFound:
        "Nenhuma cotação do índice %s encontrada para a data %s.",
      invalidTenantId: "Tenant ID não é válido.",
    },
  },
  fields: {
    additive: "Aditivo",
    apportioning: "Rateio",
    apportionmentValue: "Valor de rateio",
    balance: "Saldo",
    billing: "Valor líquido",
    branch: "Filial",
    cancellation: "Distrato",
    city: "Cidade",
    client: "Cliente",
    code: "Código",
    codeWBS: "Código",
    codItem: "Cód. Item",
    contract: "Nome do Contrato",
    contractBalance: "Saldo contrato",
    contractDate: "Data de criação do contrato",
    contractValue: "Valor contrato",
    costCenter: "Centro de Custo",
    county: "Município",
    createdDate: "Data de Cadastro",
    customer: "Cliente",
    date: "Data",
    description: "Descrição",
    discountsTotal: "Descontos",
    documentType: "Tipo Documento",
    email: "E-mail",
    executionRegime: "Regime de Execução",
    indicator: "Índice",
    installment: "Parcelamento",
    installmentNumber: "Parcela %s",
    item: "Item",
    location: "Local",
    materialUsed: "Material empregado",
    maturity: "Vencimento",
    measured: "Valor da medição",
    name: "Nome",
    newCode: "Novo código",
    paymentCondition: "Condição de Pagamento",
    percentage: "Percentual",
    period: "Período",
    project: "Nome do Projeto",
    projectErp: "Projeto",
    quantity: "Quantidade",
    readjustimentDate: "Data reajuste",
    readjustimentPercentual: "Percentual reajuste",
    receivableTotal: "Retenção e adiantamentos",
    status: "Status",
    taxesTotal: "Impostos",
    title: "Título",
    total: "Total",
    totalValue: "Valor Total",
    type: "Tipo",
    unit: "Unidade",
    unitCost: "Valor Unitário",
    unitCostShort: "Valor Unit.",
    unitCostWithCurrency: "Custo Unitário (R$)",
    value: "Valor",
  },
  login: {
    title: "Entrar no Rubk",
    startNow: "Comece Agora",
    goToLogin: "Fazer Login",
    dontHaveAnAccount: "Não possui uma conta?",
    alreadyHaveAnAccount: "Já possui uma conta?",
    forgotPassword: "Esqueceu a senha?",
    error: "Não foi possível efetuar o login com as informações indicadas.",
    newSession: "Uma nova sessão foi aberta com seu usuário.",
    register: {
      title: "Criar uma conta no Rubk",
      text: "Ao continuar, você está indicando que aceita nossos Termos de Serviço e Política de Privacidade.",
      createAccount: "Criar conta",
      error:
        "Não foi possível efetuar o registro com as informações indicadas.",
    },
    resetPassword: {
      emailSent: "E-mail de recuperação de senha enviado!",
      emailErrorSent: "Não foi possível enviar seu e-mail de recuperação.",
    },
  },
  kanban: {
    title: "Meus contratos",
    tab1: "Contratos (%s)",
    tab2: "Dashboard",
    search: "Pesquisar contrato",
    addContract: "Novo contrato",
    shareModal: {
      title: "Compartilhar Contrato",
      addEmails: "Adicione um ou mais e-mails de usuários",
      addAnother: "Adicione outro usuário",
      success: "Contrato compartilhado com sucesso!",
    },
    status: {
      aguardando: "Aguardando Início",
      andamento: "Em Andamento",
      paralisado: "Paralisado",
      concluido: "Concluído",
      arquivado: "Arquivado",
    },
    updateCoverError: "Erro ao atualizar imagem de capa: %s",
    ordering: "Ordenação",
    filterByStatus: "Filtrar por status",
    sortFields: {
      project: "Projeto",
      created_date: "Data de criação",
      status: "Status",
      total: "Valor do contrato",
      percentual: "% faturado",
    },
    saveFilterStatusError: "Erro ao salvar filtro por status: %s",
  },
  dashboard: {
    contracts: "Contratos",
    billing: "Faturamento",
    measurements: "Medições mês a mês",
    oneContract: "1 contrato",
    nContracts: "%s contratos",
    lookerTitle: "Dashboard - Faturamento",
    measureStatus: {
      andamento: "Em andamento",
      aguardando: "Aguardando aprovação",
      aprovada: "Aprovadas",
      faturada: "Faturadas",
    },
    loadError: "Erro ao carregar dados do gráfico: %s",
    select: "Selecionar",
    byDate: "Por data",
    byStatus: "Por status",
    byProject: "Por projeto",
    filterByDate: "Filtrar por data",
    clearFilters: "Limpar filtros",
    emptyTableTitle: "Nenhum projeto foi encontrado com os filtros acima.",
    emptyTableSubtitle:
      "Ajuste os filtros de data ou status, ou pesquise por outro projeto.",
    fields: {
      project: "Projeto",
      contract: "Contrato",
      client: "Cliente",
      location: "Local",
      createdAt: "Data de criação",
    },
  },
  project: {
    contractNotFound: "Desculpe, não foi possível encontrar este contrato!",
    menu: {
      importSection: {
        title: "Importação e exportação",
        import: "Importar contrato",
      },
      parameters: {
        title: "Parâmetro",
        retention: "Retenção técnica",
        discounts: "Descontos",
        taxes: "Impostos",
        advances: "Adiantamentos",
        measurementReadjustment: "Reajuste global",
      },
      settings: {
        title: "Configurações do contrato",
        readjustments: "Reajustes",
        addsAndCancels: "Aditivos e distratos",
        historic: "Histórico",
        occurrence: "Ocorrência",
        link: "Vincular orç. executivo",
        file: "Arquivar contrato",
        edit: "Editar contrato",
        delete: "Excluir contrato",
      },
      settingsMeasurement: {
        title: "Configurações da medição",
        sendToBilling: "Enviar p/ faturamento",
        delete: "Excluir medição",
        export: "Exportar medição",
        occurrences: "Ocorrências",
        recalculate: "Recalcular",
        import: "Importar medição",
        attachFiles: "Anexar arquivos",
      },
    },
  },
  importation: {
    modeFile: {
      step1: "Escolher arquivo",
      step2: "Parâmetros",
      step3: "Configuração dos campos",
      step4: "Personalização",
      stepAtt: "Anexos",
      subtitle1: "Selecione um arquivo para importação",
      subtitle2: "Configure e defina os parâmetros",
      subtitle3: "Associe as colunas do arquivo com as colunas do contrato",
      subtitle4: "Crie propriedades personalizadas para seu contrato",
      subtitleAtt: "Anexe arquivos aos aditivos importados",
      newProperty: "Nova Propriedade",
      fileCaption1:
        "Para otimizar a importação, deixe %s em um arquivo com apenas uma aba. Apenas os formatos ",
      fileCaption2: " e ",
      fileCaption3: "  são aceitos.",
      tab: "Aba",
      line: "Linha",
      startRow: "Linha que começa os dados",
      finalRow: "Linha que termina os dados",
    },
    contract: {
      title: "Importação de contrato",
      processingMessage:
        "Você pode aguardar ou fechar esta aba e voltar novamente mais tarde quando o contrato estiver pronto.",
      processedMessage:
        "Seu contrato já está pronto para ser acessado e configurado.",
      alreadyImported:
        "Este contrato já possui uma planilha importada! Para importar uma nova planilha crie um novo contrato.",
      status: {
        preparing: "Preparando importação...",
        uploading: "Estamos importando seu contrato...",
        file_uploaded: "Estamos importando seu contrato...",
        upload_error: "Erro ao upar arquivo no servidor!",
        "processing data": "Estamos importando seu contrato...",
        "processed data": "Estamos importando seu contrato...",
        processing: "Estamos importando seu contrato...",
        saving: "Estamos importando seu contrato...",
        processed: "Contrato importado com sucesso!",
        error: "Houve um erro ao importar contrato!",
      },
    },
    additive: {
      title: "Aditivar em massa",
      processingMessage:
        "Você pode aguardar ou fechar esta aba e voltar novamente mais tarde quando os aditivos estiverem prontos.",
      processedMessage:
        "Você pode conferir os aditivos importados em seu contrato.",
      status: {
        preparing: "Preparando importação...",
        uploading: "Estamos importando seus aditivos...",
        file_uploaded: "Estamos importando seus aditivos...",
        upload_error: "Erro ao upar arquivo no servidor!",
        "processing data": "Estamos importando seus aditivos...",
        "processed data": "Estamos importando seus aditivos...",
        processing: "Estamos importando seus aditivos...",
        saving: "Estamos importando seus aditivos...",
        processed: "Aditivos importados com sucesso!",
        error: "Houve um erro ao importar os aditivos!",
      },
    },
    measurement: {
      title: "Importar medição",
      measureBy: "Forma de medir",
      processingMessage:
        "Você pode aguardar ou fechar esta aba e voltar novamente mais tarde quando a medição estiver pronta.",
      processedMessage: "Você pode conferir a medição importada.",
      status: {
        preparing: "Preparando importação...",
        uploading: "Estamos importando sua medição...",
        file_uploaded: "Estamos importando sua medição...",
        upload_error: "Erro ao upar arquivo no servidor!",
        "processing data": "Estamos importando sua medição...",
        "processed data": "Estamos importando sua medição...",
        processing: "Estamos importando sua medição...",
        saving: "Estamos importando sua medição...",
        processed: "Medição importada com sucesso!",
        error: "Houve um erro ao importar a medição!",
      },
    },
    errorOnSchedule:
      "Por favor, verifique se todos os campos estão preenchidos corretamente e tente importar novamente.",
    errorOnProcess:
      "Por favor, verifique se os dados da planilha estão preenchidos corretamente e tente importar novamente.",
    notFound: "não encontrado",
    emptyWorksheet: "Planilha vazia",
    yourBudget: "seu orçamento",
    yourAdditives: "seus aditivos",
    theMeasurement: "a medição",
    errors: {
      "Quantity must be a numerical value":
        "Quantidade deve ter um valor numérico",
      "UnitCost must be a numerical value":
        "Custo Unitário deve ter um valor numérico",
      "Total must be a numerical value": "Total deve ter um valor numérico",
      "Quantity must be a positive number":
        "Quantidade deve ser um número positivo",
      "UnitCost must be a positive number":
        "Custo Unitário deve ser um número positivo",
      "Total must be a positive number": "Total deve ser um número positivo",
      "Percentage must be a numerical value":
        "Percentual deve ter um valor numérico",
      "value not found in the description column":
        "valor não encontrado na coluna descrição",
      "value not found in the codeWBS column":
        "valor não encontrado na coluna código",
      "Mandatory parameter field": "Parâmetro obrigatório - campo ",
      "Mandatory property [name] in field not found":
        "Propriedade obrigatória [name] não encontrada no campo",
      "Mandatory property [column] in field not found":
        "Propriedade obrigatória [column] não encontrada no campo",
      "Contract line already exists": "Linha do contrato já existe",
      "Parent line not found": "Linha pai não encontrada",
      "Parent line is not a stage": "Linha pai não é uma etapa",
      "Contract line not found": "Linha do contrato não encontrada",
      "Value less than zero": "Valor menor que zero",
      "Value greater than the balance": "Valor maior que o saldo",
      "Invalid codeWBS": "Código inválido",
      "No data to import": "Não há dados para importar",
    },
  },
  contract: {
    label: "Contrato",
    integration: "Integração",
    newContractTitle: "Criar um novo contrato",
    editContractTitle: "Editar contrato",
    deleteContractTitle: "Excluir contrato",
    deleteMessage:
      "Tem certeza que deseja excluir este contrato? Está ação não poderá ser desfeita depois.",
    deleteSuccess: "Contrato deletado com sucesso!",
    descriptionChange: "Alteração da descrição",
    descriptionChangeMessage:
      "Deseja salvar as alterações feitas na descrição?",
    status: "Status do Contrato",
    executionRegime: {
      global: "Empreitada Global",
      unitPrice: "Preço Unitário",
    },
    executiveBudget: {
      title: "Vincular orçamento executivo",
      updated: "Orçamento vinculado com sucesso!",
      removed: "Vínculo com orçamento removido com sucesso!",
      error: "Erro ao vincular orçamento ao contrato!",
      fields: {
        branch: "Selecionar filial",
        budget: "Selecionar orçamento executivo",
      },
    },
    errors: {
      fetchData: "Não foi possível carregar os dados do ERP Mega.",
      authentication: "Não foi possível realizar a autenticação.",
      client: "Não foi possível localizar o cliente.",
      branch: "Não foi possível obter as filiais.",
      paymentCondition: "Não foi possível obter as condições de pagamento.",
      documentType: "Não foi possível obter os tipos de documento.",
      budget: "Não foi possível obter os Orçamentos.",
      costCenter: "Não foi possível obter os centros de custo.",
      projectErp: "Não foi possível obter os projetos.",
      productItems: "Não foi possível obter os itens",
      finacialIndicators: "Não foi possível obter os indicadores financeiros",
      finacialIndicatorQuotation:
        "Não foi possível obter a cotação do indicador financeiro.",
      deleteWithMeasurement:
        "Seu contrato não foi excluído, pois há medições criadas. \nPor favor, apague todas as medições e tente novamente.",
      deleteShared: "O contrato só pode ser deletado pelo sue proprietário.",
      updateQuantity: "Não foi possível alterar a quantidade.",
      quantityLessThanBalance:
        "A quantidade não pode ser menor do que já foi medido, somente igual ou maior ao saldo.",
      descriptionChange: "Não foi possível alterar a descrição: %s",
    },
  },
  measurements: {
    newMeasurement: "Nova medição",
    deleteMeasurementTitle: "Excluir Medição",
    deleteMeasurementContent:
      "Tem certeza que deseja excluir esta medição ? Esta ação não poderá ser desfeita depois.",
    defaultName: "Medição %s",
    measuremntLink: "Vinculado à %s",
    noLink: "Sem vínculo",
    deleted: "Medição excluída com sucesso.",
    loadingTable: "Carregando detalhes da medição...",
    loadingStage: "Por gentileza, aguarde o carregamento desta medição.",
    waitForUpdate:
      "Alterações na medição estão sendo salvas. Por favor, aguarde!",
    updateFailed:
      "Não foi possível atualizar os dados da medição!\nClique no botão ao lado e tente novamente.",
    status: {
      andamento: "Em andamento",
      aguardando: "Aguardando Aprovação",
      aprovada: "Aprovada",
      faturada: "Faturada",
    },
    updateStatus: {
      saving: "Salvando...",
      save: "Salvo!",
      error: "Erro ao salvar!",
      calculating: "Calculando...",
    },
    error: {
      notFound: "Medição não encontrada!",
      save: "Houve um erro ao salvar a medição.",
      delete: "Houve um erro ao deletar a medição.",
      updateBilled: "Não é possível editar uma medição faturada.",
      deleteBilled: "Não é possível deletar uma medição faturada.",
      sendToBilling: "Erro ao enviar medição para faturamento",
      noProductsToBilling:
        "Nenhum item de produto foi selecionado para faturamento. \nPor favor, selecione ao menos um produto.",
      noCitiesToBilling:
        "Nenhum item de município foi informado para faturamento. \nPor favor, adicione ao menos um município.",
      valueGreaterThanBalance:
        "Não é possível medir um valor maior que o total contratado do serviço.",
      invalidTotal: {
        discounts:
          "Total de descontos não pode ser maior que o Total Líquido da medição.",
        advances:
          "Total de adiantamentos não pode ser maior que o Total Líquido da medição.",
      },
      invalidDates:
        "Data final do período não pode ser menor que a data inicial",
      billing: {
        canceled:
          "Imortação do pedido no ERP foi cancelada! \nPor favor, refaça o envio para faturamento ou verifique com o responsável pelo lançamento do pedido.",
        error:
          "Ocorreu um erro na imortação do pedido no ERP! \nPor favor, refaça o envio para faturamento ou verifique com o responsável pelo lançamento do pedido.",
      },
      zeroUnitValue: "Não é possível medir um serviço sem valor unitário.",
    },
    table: {
      measured: "Medição acumulada",
      measuredTotal: "Acumulado total",
      measuredCurrent: "Acumulado até esta medição",
      current: "Medição atual",
      billing: "Saldo a Medir",
      calculating: "Calculando dados...",
      advancesTotal: "Total adiantamento",
      billingsTotal: "Total faturamento direto",
      retentionTotal: "Total retenção técnica",
      measuredPercentual: "% medido",
      accumuledPercentual: "% acumulado",
      grossInvoiceAmount: "Valor da Nota Fiscal",
      orderCode: "Documento de Venda",
      invoices: "Nota Fiscal",
      serial: "Série",
      issuanceDate: "Data de Emissão",
      buttonBilling: "Enviar para Faturamento",
      taxes: {
        title: "Impostos",
        iss: "ISS",
        inss: "INSS",
        cofins: "COFINS",
        pis: "PIS",
        csll: "CSLL",
      },
      retentionAndAdvances: {
        title: "Retenção e adiantamentos",
        retention: "Retenção técnica",
        advanceDiscount: "Desconto do adiantamento",
      },
      discounts: {
        title: "Descontos",
        directBilling: "Faturamento direto",
        totalExtraordinaryDiscount: "Total desconto extraordinário",
      },
      measurementInformation: {
        title: "Informações da medição",
        measuredValue: "Valor medido",
        readjustment: "Reajuste da medição",
      },
      otherInformation: {
        title: "Outras informações",
        salesDocument: "Documento de venda",
        balanceToMeasure: "Saldo a medir",
        measuredPercent: "% medido",
        accumulatedPercentage: "% acumulado",
      },
      details: {
        orderInProgress: "Aguardando gerar documento de venda",
        invoiceInProgress: "Aguardando gerar nota fiscal",
        orderDeleted:
          "Documento de venda excluído. Por favor, reenvie para faturamento.",
        orderError:
          "Erro ao gerar o documento de venda. Tente enviar para faturamento novamente.",
      },
    },
  },
  retention: {
    title: "Configurar retenção técnica",
    label: "Percentual",
    label2: "Base de cálculo",
    success: "Retenção técnica configurada com sucesso.",
    options: {
      measurementTotal: "Valor medido",
      grossTotal: "Valor medido - Faturamento direto",
    },
  },
  discounts: {
    title: "Painel de Descontos",
    new: "Novo desconto",
    billingTotal: "Saldo",
    amount: "Total",
    formTitle: "Novo desconto",
    formTitleOnEditMode: "Editar desconto",
    fields: {
      quantity: "Quantidade parcelas",
      link: "Vínculo com medição",
      types: {
        discount: "Desconto",
        billing: "Faturamento direto",
      },
    },
    types: {
      desconto: "Desconto",
      faturamento: "Faturamento direto",
    },
    deleteModal: {
      title: "Deletar desconto",
      text: "Você tem certeza que deseja deletar este desconto?",
    },
    linkModal: {
      title: "Vincular descontos",
      notFound: {
        title:
          "Não foi encontrado nenhum desconto cadastrado para este contrato!",
        subtitle:
          "Para adicionar descontos, volte para a seção de contrato e clique em ",
        trail: "'Opções (...) > Descontos.'",
      },
    },
    success: {
      created: "Desconto adicionado com sucesso.",
      updated: "Desconto alterado com sucesso.",
      deleted: "Desconto deletado com sucesso.",
      linked: "Desconto(s) vinculado(s) a medição com sucesso!",
    },
    error: {
      totalDiff: "A soma das parcelas é diferente do valor do desconto.",
      onUpdateTotal:
        "Total não pode ser menor que o total de parcelas vínculadas.",
      onUpdateQuantity:
        "A quantidade de parcelas não pode ser menor que a quantidade de parcelas vínculadas.",
      onUpdateMaturityDate:
        "A data da parcela não pode ser menor que a data do desconto.",
      onDeleteWithMeasurement:
        "Não é possível deletar descontos com parcelas vinculadas à medições",
      onLinkMeasurement: "Não foi possível vincular os descontos a medição!",
      noLink:
        "É necessário assinalar ao menos uma parcela para realizar o vínculo.",
    },
  },
  advances: {
    title: "Painel de Adiantamentos",
    new: "Novo adiantamento",
    balance: "Saldo",
    amount: "Total",
    formTitle: "Novo adiantamento",
    formTitleOnEditMode: "Editar adiantamento",
    fields: {
      quantity: "Quantidade parcelas",
      link: "Vínculo com medição",
    },
    deleteModal: {
      title: "Deletar adiantamento",
      text: "Você tem certeza que deseja deletar este adiantamento?",
    },
    linkModal: {
      title: "Vincular adiantamentos",
      notFound: {
        title:
          "Não foi encontrado nenhum adiantamento cadastrado para este contrato!",
        subtitle:
          "Para adicionar adiantamentos, volte para a seção de contrato e clique em ",
        trail: "'Opções (...) > Adiantamentos.'",
      },
    },
    success: {
      created: "Adiantamento adicionado com sucesso.",
      updated: "Adiantamento alterado com sucesso.",
      deleted: "Adiantamento deletado com sucesso.",
      linked: "Adiantamento(s) vinculado(s) a medição com sucesso!",
    },
    error: {
      totalDiff: "A soma das parcelas é diferente do valor do adiantamento.",
      onUpdateTotal:
        "Total não pode ser menor que o total de parcelas vínculadas.",
      onUpdateQuantity:
        "A quantidade de parcelas não pode ser menor que a quantidade de parcelas vínculadas.",
      onDeleteWithMeasurement:
        "Não é possível deletar adiantamentos com parcelas vinculadas à medições",
      onLinkMeasurement:
        "Não foi possível vincular os adiantamentos a medição!",
      noLink:
        "É necessário assinalar ao menos uma parcela para realizar o vínculo.",
    },
  },
  taxes: {
    title: "Impostos",
    success: "Impostos configurados com sucesso.",
    fields: {
      inss: "INSS",
      iss: "ISS",
      pis: "PIS",
      cofins: "Cofins",
      csll: "CSLL",
    },
  },
  integrationSetup: {
    title: "Integração",
    configuration: "Configurar",
    titleForm: "CONFIGURAÇÕES DA INTEGRAÇÃO",
    software: "Software",
    host: "URL da integração",
    user: "Usuário do software",
    password: "Senha do software",
    tenantId: "Tenant ID",
    success: {
      updated: "Configurações atualizadas com sucesso.",
    },
    seeMoreConfig: "Saiba como configurar corretamente.",
    seeMore: "Saiba mais.",
    error: {
      missIntegration:
        "Para víncular um orçamento executivo, é necessário configurar a integração.",
      integration: "A URL de integração está inválida.",
      userAndPass:
        "Seu usuário e/ou senha estão incorretos. Por favor, tente novamente.",
      userBlock: "Este usuário está bloqueado.",
      userPermission: "Este usuário não possui permissão. ",
      invalidTenantId: "Tenant ID está incorreto. Por favor, tente novamente.",
    },
  },
  measurementExport: {
    title: "Exportar medição",
    format: "Formato",
    itemsToExport: "Itens a exportar",
    filterByStage: "Filtrar por etapa(s)",
    loadMoreStages: "Carregar mais etapas",
    selectStageInfo: "Selecione ao menos uma etapa para exportação.",
    typeOptions: {
      current: "Esta medição",
      all: "Todas as medições",
      onlyMeasured: "Esta medição, apenas o que foi medido",
    },
    filterOptions: {
      all: "Todas as etapas",
      filter: "Filtrar por etapas",
    },
    loadindData: "Carregando os dados...",
    header: {
      project: "Projeto",
      contract: "Contrato",
      client: "Cliente",
      location: "Local",
      measurement: "Medição",
      period: "Período",
    },
    bands: {
      contract: "Contrato",
      accumulated: "Medição Acumulada",
      actual: "Medição Atual",
      balance: "Saldo a Medir",
    },
    footer: {
      totals: "Totais",
      advance: "Adiantamentos",
      discount: "Descontos",
      billingDiscount: "Descontos Faturamento Direto",
      taxes: "Impostos",
      retention: "Retenção",
      contract: "Total Contrato",
      billing: "Total a Medir",
      invoice: "Valor da Nota Fiscal",
      netTotal: "Valor Líquido",
    },
  },
  billing: {
    title: "Enviar para faturamento",
    steps: {
      client: "Cliente",
      measurement: "Medição",
      itemSelection: "Seleção de itens",
      resourcesByCounty: "Recursos por município",
      resume: "Resumo",
    },
    fields: {
      totalMeasured: "Total medido",
      billing: "Faturamento direto",
      totalReceivable: "Total a receber",
    },
    autoApportioning: "Rateio automático",
    manualApportioning: "Rateio manual",
    materialUsedTooltip: "Não é aplicado ISS nem INSS",
    success: "Dados enviados para o faturamento com sucesso.",
    error: "Não foi possivel enviar os dados para faturamento",
    alreadyBilled:
      "O faturamento desta medição já foi enviado! Por favor, selecione outra medição para o envio.",
    noAuth:
      "Não foi possível se conectar ao ERP Mega. Por favor, verifique se os seus dados de conexão estão corretos.",
    noItems: "Nenhum registro encontrado.",
    noResults: "Nenhum registro correspondente a busca foi encontrado.",
    noPattern: "Padrão do Cliente não encontrado",
    valueErrorMessage: "Valor deve ser igual ou menor ao saldo",
    percentageErrorMessage: "Percentual deve ser igual ou menor ao saldo",
    measurementAndReadjustment: "Medição + Reajuste",
    newCounty: "Novo município",
    apportionmentTypes: {
      medição: "Medição",
      reajuste: "Reajuste",
      mediçãoMaisReajuste: "Medição + Reajuste",
    },
    salesDocument: "Documento de venda",
    separateReadjustment: "Separar reajuste",
  },
  indicatorsPage: {
    charts: {
      contract: {
        title: "Contrato",
        chartLabel: "Indicadores - Contrato",
      },
      budget: {
        title: "Orçamento Executivo",
        chartLabel: "Indicadores - Orçamento Executivo",
      },
    },
    addsAndCancels: {
      title: "Total de Aditivos e Distratos",
      adds: "Aditivos",
      cancels: "Distratos",
      details: "Detalhes",
      modalTitle: "Detalhes de Aditivos, Distratos e outras alterações",
      otherChanges: "Outras alterações",
      structured: "Cód.",
      description: "Descrição",
      quantityApplied: "Qtde. aditivada",
      quantityCanceled: "Qtde. distratada",
      totalApplied: "Total",
      date: "Data",
      userName: "Usuário",
      descriptionBefore: "Descrição (ANTES)",
      descriptionAfter: "Descrição (DEPOIS)",
      quantityBefore: "Qtde. (ANTES)",
      quantityAfter: "Qtde. (DEPOIS)",
    },
    noLink:
      "Para exibir os indicadores referentes a custo, você precisa vincular seu contrato ao seu orçamento executivo.",
  },
  addsAndCancels: {
    title: "Aditivos e Distratos",
    formsTypes: {
      additiveRow: "Aditivar linha inteira",
      additiveQuantity: "Aditivar quantidade",
      cancellationRow: "Distratar linha inteira",
      cancellationQuantity: "Distratar quantidade",
      cancellationMass: "Distratar em massa",
    },
    qttAddHelp: "Quanto você deseja aditivar?",
    qttCancelHelp: "Quanto você deseja distratar?",
    addInBulk: "Aditivar em massa",
    codes: "Código(s)",
    codesHelperText:
      "Adicione vários códigos separando-os com ponto e vírgulas",
    messages: {
      success: {
        additive: "Aditivo aplicado com sucesso.",
        cancellation: "Distrato aplicado com sucesso.",
      },
      error: {
        additive:
          "Houve um erro inesperado. Atualize a página para tentar novamente. Erro: %s",
        cancellation:
          "Houve um erro inesperado. Atualize a página para tentar novamente. Erro: %s",
        existedCode:
          "Este código já existe. Confira o contrato e tente novamente.",
        inexistedCode:
          "Código inexistente. Confira o contrato e tente novamente.",
        invalidCode: "Código inválido. Confira o contrato e tente novamente.",
        invalidQuantity:
          "Não é possível distratar pois o saldo é menor que quantidade a ser distratada.",
        parentRowNotFound: "Linha pai não encontrada [%s]",
        parentRowIsNotStage: "Linha pai não é uma etapa [%s]",
        balanceGreaterThanZero:
          "Não é possível distratar pois há uma ou mais linhas com saldo igual ou menor a zero.",
      },
    },
  },
  lineHistory: {
    title: "Detalhes",
    totalContract: "Valor total contrato",
    description: "Descrição",
    oldDescription: "Descrição antiga",
    qtts: {
      Aditivo: "Quantidade aditivada",
      Distrato: "Quantidade distratada",
      Alterado: "Quantidade alterada",
    },
    indicator: {
      manual: "Reajuste Manual",
      percentual: "Percentual de reajuste",
      total: "Valor contrato após reajuste",
      balance: "Saldo contrato após reajuste",
    },
    types: {
      Contrato: "Linha original",
      Aditivo: "Aditivo",
      Distrato: "Distrato",
      Reajuste: "Reajuste",
      Alterado: "Alteração",
      AlteradaDescricao: "Alteração da descrição",
    },
  },
  contractReadjustment: {
    title: "Reajuste",
    contractTotal: "Valor contrato após reajuste",
    contractBalance: "Saldo contrato após reajuste",
    manual: "Reajuste manual",
    messages: {
      success: "Reajuste aplicado com sucesso.",
    },
  },
  measurementReadjustment: {
    title: "Configurar reajuste de medição",
    readjust: "Valor do reajuste",
    messages: {
      success: "Reajuste da medição alterado com sucesso!",
    },
  },
  dropzone: {
    empty: "Selecionar arquivo local",
    dropHere: "Solte o arquivo aqui...",
  },
  pagination: {
    rowsPerPage: "Linhas por página:",
    backText: "Página anterior",
    nextText: "Próxima página",
  },
  errorPages: {
    notFound: "Desculpe, página não encontrada.",
  },
  userProfile: {
    myProfile: "Meu perfil",
    enterprise: "Empresa",
    collaborators: "Colaboradores",
    accessProfile: "Perfil de acesso",
    addProfile: "Cadastrar novo perfil",
    noProfileFound: "Nenhum perfil foi encontrado.",
    users: "%s usuário(s)",
    createProfile: "Criar perfil",
    thisProfileAlreadyExists: "Este perfil já existe. Digite novamente.",
    profileEditedSuccessfully: "Perfil editado com sucesso.",
    errorEditingProfile: "Erro ao editar perfil: %s",
    profileCreatedSuccessfully: "Novo perfil criado com sucesso.",
    errorCreatingProfile: "Erro ao criar perfil: %s",
    profileCannotBeDeleted:
      "Esse perfil não pode ser excluído, pois existem usuários vinculados.",
    profileDeletedSuccessfully: "Perfil deletado com sucesso.",
    errorDeletingProfile: "Erro ao deletar perfil: %s",
    unableToChangeEmployee:
      "Não foi possível alterar o perfil de acesso do colaborador! %s",
    profileDoesNotAllow: "Seu perfil não permite esta ação",
    processes: {
      configuracoes: "Configurações",
      gerar_contrato: "Gerar contrato",
      editar_contrato: "Editar contrato",
      excluir_contrato: "Excluir contrato",
      gerar_aditivo: "Gerar aditivo",
      gerar_distrato: "Gerar distrato",
      anexar_arquivos: "Anexar arquivos",
      gerar_medicoes: "Gerar medições",
      aprovar_medicoes: "Aprovar medições",
      excluir_medicoes: "Excluir medições",
      criar_documento_de_venda: "Criar documento de venda",
      indicadores: "Indicadores",
    },
  },
  attachments: {
    attachFiles: "Anexar arquivos",
    uploadError: "Erro no upload",
    waitUpload: "Aguarde os anexos serem upados!",
    errors: {
      uploadError:
        "Ocorreu um erro ao fazer o upload do arquivo. Por favor, tente novamente.",
      removeError: "Ocorreu um erro ao remover arquivo.",
      saveError: "Ocorreu um erro ao salvar os arquivos anexados.",
      invalidFormat:
        "O formato do arquivo selecionado não é suportado.\nPor favor, escolha um arquivo em um formato aceito.",
      maximumSize:
        "Um ou mais arquivos selecionados são maiores que 100MB.\nEscolha um arquivo menor para anexar.",
      maximumFilesCount:
        "Você excedeu o número máximo de arquivos que podem ser anexados.\nPor favor, remova um ou mais arquivos e tente novamente.",
      invalidFile:
        "O arquivo que você está tentando anexar parece estar corrompido.\nPor favor, verifique o arquivo e tente novamente.",
    },
  },
  exportData: {
    project: "Projeto",
    contract: "Contrato",
    customer: "Cliente",
    location: "Local",
    description: "Descrição",
    measurements: {
      title: "Medições",
      total: "Valor da medição",
      totals: "Totais",
      discounts: "Descontos",
      grossTotal: "Valor da Nota Fiscal",
      retentionAdvance: "Retenção e Adiantamentos",
      taxes: "Impostos",
      netTotal: "Valor Líquido",
      status: "Status",
      invoiceNumber: "Nota Fiscal",
      invoiceSerial: "Série",
      invoiceDate: "Data de Emissão",
      period: "Período",
      orderCode: "Documento de Venda",
      balanceToMeasure: "Saldo a Medir",
      measuredPercentual: "% medido",
      accumulatedPercentual: "% acumulado",
      clientName: "Nome do Cliente",
    },
    addsAndCancels: "Aditivos_e_Distratos",
  },
};
